// Title
export const TITLE = `Starry Night Coding`;

// Aside
export const ASIDE_PROFILE = `https://scontent-ssn1-1.cdninstagram.com/v/t51.2885-19/s320x320/33567692_2115547688688613_1015315618640953344_n.jpg?tp=1&_nc_ht=scontent-ssn1-1.cdninstagram.com&_nc_ohc=x1Gd6JbI0pYAX9oRfPf&edm=ABfd0MgAAAAA&ccb=7-4&oh=bf0135c8c66e2308fe88b70b8df14224&oe=60AA26C8&_nc_sid=7bff83`;
export const ASIDE_INSTAGRAM = `https://www.instagram.com/juddroid_raccoon/`;

export const LARGE = 'large';
export const MEDIUM = 'medium';
export const SMALL = 'small';
export const SIZE_DEFAULT_WIDTH = 100;
export const SIZE_DEFAULT_HEIGHT = 50;
